import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro-individual`

    return {
        index() {
            return repository.get(`${baseUrl}`);
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        datatable(queryParams) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParams)}`)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {

            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getSupervisor(queryParms) {
            return repository.get(`${baseUrl}/supervisor?${urlUtil.serialize(queryParms)}`)
        },
        comunidade: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-comunidade?${urlUtil.serialize(queryParms)}`)
            },
        },
        getListData() {
            return repository.get(`${baseUrl}/list-data`)
        },
    }
}